import { useEffect, useRef } from "react";

export default function Logo3D({ size = 32 }) {
    const wrapRef = useRef(null);

    useEffect(() => {
        if (!wrapRef.current) return;
        // three.js se carga en un chunk aparte para no bloquear el primer render
        let scene = null;
        let io = null;
        let cancelled = false;
        import("@/three/logoScene").then(({ createLogoScene }) => {
            if (cancelled || !wrapRef.current) return;
            scene = createLogoScene(wrapRef.current);
            io = new IntersectionObserver(
                (entries) => entries.forEach((e) => (e.isIntersecting ? scene.resume() : scene.pause())),
                { threshold: 0.01 },
            );
            io.observe(wrapRef.current);
        });
        return () => {
            cancelled = true;
            io?.disconnect();
            scene?.dispose();
        };
    }, []);

    return (
        <div
            ref={wrapRef}
            aria-hidden="true"
            data-testid="logo-3d"
            style={{ width: size, height: size, flexShrink: 0 }}
        />
    );
}
